import React from 'react';
import { Button, SxProps, Theme } from '@mui/material';

import { ReadFile, SelectFile } from '@paragon/client-tools';

interface Props {
  readonly onUpload: (pFile: readonly Promise<ReadFile>[]) => void;
  readonly buttonSx: SxProps<Theme>;
  readonly id: string;
  readonly buttonText: string;
  readonly accept: string;
  readonly multiple: boolean;
}

export default class Upload extends React.Component<Props> {
  fileSelect?: SelectFile | null;

  onFilesLoading = (pFilesLoading: readonly Promise<ReadFile>[]) => {
    if (pFilesLoading.length > 0) {
      this.props.onUpload(pFilesLoading);
    }
  };

  click = () => {
    if (this.fileSelect) this.fileSelect.click();
  };

  render() {
    return (
      <div>
        <Button variant="outlined" onClick={() => this.click()} component="span" sx={this.props.buttonSx}>
          {this.props.buttonText}
          <SelectFile
            id={this.props.id}
            hide
            onChange={this.onFilesLoading}
            multiple={this.props.multiple}
            accept={this.props.accept}
            ref={(item) => {
              this.fileSelect = item;
            }}
          />
        </Button>
      </div>
    );
  }
}
